import { useState, useEffect } from "react";
import { purchasePoService } from "../purchasePoService"
import { usePurchasePoModel } from "../purchasePoModel";
import { IPurchasePoDetail } from "../purchasePoType"
import { shopService } from "@/views/organization/shop/shopService"
import { materialService } from "@/views/base/material/materialService"
import { momentFormat } from '@/utils/utils';
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void
}

export const PrintTable = (props: PropsType) => {
  const { printVisible, setPrintVisible } = props;
  const { selectedRow } = usePurchasePoModel();
  const searchParams = { pageSize: -1, pageNum: 1 }
  const [pageCount, setPageCount] = useState<number>(0);
  const [dataSource, setDataSource] = useState<any>();

  const fetchAllData = async (data: IPurchasePoDetail) => {
    try {
      const { retData } = await shopService.page({
        sourceApp: "vrm", page: searchParams, name: selectedRow.shopName
      })
      if (retData.records.length > 0) {
        return retData.records[0].prefix
      }
      return ''
    }
    catch (error) {
      console.error('Error fetchAllData:', error);
    }
  }
  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printVisible) {
      purchasePoService.one(selectedRow.purchaseCode).then((res) => {
        const data = res.retData;
        if (data.length !== 0) {
          fetchAllData(data).then((result) => {
            const newData = {
              ...data,
              shopPrefix: result
            }
            setPageCount(1);
            setDataSource(newData);
            print();
          })
        }
      });
    }
    else {
      setPrintVisible(false);
    }
  }, [printVisible])

  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        {Array.from({ length: pageCount }).map((_, pageIndex) => (
          <div key={pageIndex} style={{ display: 'flex', width: '100%', height: '100%' }}>
            <div style={{ flex: 50 }}>
              <div style={{ textAlign: 'center', fontSize: 24, fontFamily: "FangSong", fontWeight: 'normal', marginTop: 40 }}>
                {`${shopName}`}
              </div>
              <div style={{ textAlign: 'center', fontSize: 20, fontFamily: "FangSong", fontWeight: 'normal' }}>
                材料验收单
              </div>
              <div style={{ textAlign: 'right', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', margin: '0px 10% 10px 0px' }}>
                单据编号: {dataSource?.purchaseCode}
              </div>
              <table className="mingxi" style={{ border: "1px solid black", width: "100%" }}>
                <thead>
                  <tr style={{ height: 25 }}>
                    <th colSpan={2} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>材料仓库</th>
                    <th colSpan={3} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>{dataSource?.details[0].warehouseName}({dataSource?.shopPrefix})</th>
                    <th colSpan={1} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>入库时间</th>
                    <th colSpan={2} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>{momentFormat(dataSource?.stockIoTime ?? "", "YYYY年MM月DD日")}</th>
                    <th colSpan={1} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>供货单位</th>
                    <th colSpan={5} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>{dataSource?.supplierName}</th>
                  </tr>
                  <tr style={{ height: 25 }}>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>序号</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>采购批次</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>材料编码</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>材料大类</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>材料小类</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>材料名称</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>品牌</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>适用车型</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>规格、型号</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>采购单位</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>采购数量</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>仓库单位</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>仓库数量</th>
                    <th style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>备注</th>
                  </tr>
                </thead>
                <tbody>
                  {dataSource?.details.slice(pageIndex * 20, (pageIndex + 1) * 20).map((row: any, rowIndex: any) => (
                    <tr key={rowIndex} style={{ height: 25 }}>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{rowIndex + 1}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{dataSource?.purchaseCode}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialCode}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.ptypeCode != null ? row.ptypeName : row.typeName}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.ptypeCode != null ? row.typeName : ''}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialName}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.brandCode ? row.brandName : ''}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.vehicleModel}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.model}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.brandCode ? row.brandName : ''}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.num}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.brandCode ? row.brandName : ''}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.num}</td>
                      <td style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.note}</td>
                    </tr>
                  ))}
                  {Array.from({
                    length: 20 - (dataSource?.details ?? [])?.slice(
                      pageIndex * 20,
                      (pageIndex + 1) * 20
                    ).length
                  }).map((_, i) => (
                    <tr key={`empty-${i}`} style={{ height: 25 }}>
                      <td style={{ width: 28, fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{(dataSource?.details ?? []).slice(pageIndex * 20, (pageIndex + 1) * 20).length + i + 1}</td>
                      {Array(13).fill(null).map((_, i) => (
                        <td key={i} style={{ fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>&nbsp;</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ display: 'flex', margin: 10, padding: 10, fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>
                <div style={{ flex: 1 }}>验收:</div>
                <div style={{ flex: 1 }}>采购：</div>
                <div style={{ flex: 1 }}>库管:</div>
                <div style={{ flex: 1 }}>制单: {dataSource?.createUser}</div>
              </div>
            </div>
            <div style={{ flex: 1, writingMode: "vertical-rl" }}>
              <span style={{ marginTop: '20%', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>此单据一式四联</span>
              <span style={{ marginTop: '5%', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>第一联底联白</span>
              <span style={{ marginTop: '5%', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>第二联采购部蓝</span>
              <span style={{ marginTop: '5%', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>第三联库房红</span>
              <span style={{ marginTop: '5%', fontSize: 10, fontFamily: "FangSong", fontWeight: 'normal' }}>第四联财务黄</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};